import { useState, useEffect } from "react";
import { Space } from "antd";
import TokenSettings from "./components/TokenSettings";
import TokenPrompt from "./components/TokenPrompt";
import BinTable from "./components/BinTable";
import BinEditorModal from "./components/BinEditorModal";
import LanguageSwitcher from "./components/LanguageSwitcher";
import ThemeSwitcher from "./components/ThemeSwitcher";
import { getToken } from "./utils/api";
import { useLocale } from "./contexts/LocaleContext";

export default function App() {
  const [selectedBinId, setSelectedBinId] = useState<string | null>(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [hasToken, setHasToken] = useState(() => !!getToken());
  const { t } = useLocale();

  const handleTokenChange = () => {
    setHasToken(!!getToken());
    setRefreshKey((k) => k + 1);
  };

  const handleCreateNew = () => {
    setSelectedBinId(null);
    setIsEditorOpen(true);
  };

  const handleEdit = (binId: string) => {
    setSelectedBinId(binId);
    setIsEditorOpen(true);
  };

  const handleEditorSuccess = () => {
    setRefreshKey((k) => k + 1);
  };

  const handleEditorClose = () => {
    setIsEditorOpen(false);
    setSelectedBinId(null);
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-heading font-bold text-text mb-2">
              {t.app.title}
            </h1>
            <p style={{ color: "var(--text-secondary)" }}>{t.app.description}</p>
          </div>
          <Space>
            <ThemeSwitcher />
            <LanguageSwitcher />
          </Space>
        </div>

        <div className="mb-6">
          <TokenSettings onTokenChange={handleTokenChange} />
        </div>

        {!hasToken && (
          <div className="mb-6">
            <TokenPrompt />
          </div>
        )}

        {hasToken && (
          <div className="mb-6">
            <BinTable
              key={refreshKey}
              onEdit={handleEdit}
              onCreateNew={handleCreateNew}
              refreshKey={refreshKey}
            />
          </div>
        )}

        <BinEditorModal
          open={isEditorOpen}
          binId={selectedBinId}
          onClose={handleEditorClose}
          onSuccess={handleEditorSuccess}
        />
      </div>
    </div>
  );
}
